import { FoundationElement } from "../foundation-element/foundation-element.js";
/**
 * An Card Custom HTML Element.
 *
 * @slot - The default slot for the card content
 *
 * @public
 */
export class Card extends FoundationElement {
}
